import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../firebase';

// const storage = getStorage(app); // Rimosso perché storage è già esportato da firebase.ts

export const uploadImage = async (file: File, path: string): Promise<string> => {
  try {
    const storageRef = ref(storage, path);
    const snapshot = await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(snapshot.ref);
    return downloadURL;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw new Error('Errore durante il caricamento dell\'immagine');
  }
};

export const deleteImage = async (imageUrl: string): Promise<void> => {
  try {
    const imageRef = ref(storage, imageUrl);
    await deleteObject(imageRef);
  } catch (error) {
    console.error('Error deleting image:', error);
    // Non lanciare errore se l'immagine non esiste
  }
};

export const generateImagePath = (
  type: 'experiences' | 'artworks' | 'trails' | 'producers' | 'events' | 'quizzes' | 'souvenirs',
  id: string,
  filename: string
): string => {
  const timestamp = Date.now();
  const extension = filename.split('.').pop();
  return `${type}/${id}/images/${timestamp}.${extension}`;
};
